"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LensBottom = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var clamp_1 = require("../../lib/clamp");
var Lens_1 = require("./Lens");
exports.LensBottom = (0, react_1.forwardRef)(function (props, ref) {
  var cursorOffset = props.cursorOffset,
    position = props.position,
    fadeDurationInMs = props.fadeDurationInMs,
    isActive = props.isActive,
    isPositionOutside = props.isPositionOutside,
    parentSpecifiedStyle = props.style,
    rest = __rest(props, ["cursorOffset", "position", "fadeDurationInMs", "isActive", "isPositionOutside", "style"]);
  var typedRef = ref;
  if (!(typedRef === null || typedRef === void 0 ? void 0 : typedRef.current)) {
    return null;
  }
  var clearLensHeight = cursorOffset.y * 2;
  var computedHeight = typedRef.current.offsetHeight - position.y - cursorOffset.y;
  var maxHeight = typedRef.current.offsetHeight - clearLensHeight;
  var height = (0, clamp_1.clamp)(computedHeight, 0, maxHeight);
  var clearLensBottom = position.y + cursorOffset.y;
  var top = Math.max(clearLensBottom, clearLensHeight);
  var computedStyle = {
    height: "".concat(height, "px"),
    width: '100%',
    top: "".concat(top, "px")
  };
  return (0, jsx_runtime_1.jsx)(Lens_1.Lens, Object.assign({
    fadeDurationInMs: fadeDurationInMs,
    isActive: isActive,
    isPositionOutside: isPositionOutside,
    style: Object.assign(Object.assign({}, parentSpecifiedStyle), computedStyle)
  }, rest), void 0);
});
exports.LensBottom.displayName = 'LensBottom';